(function hpSlider() {
  const isCompExists = GlobalSite.checkDependency('GlobalSite.isCompExists');
  const compName = 'hp_banner';
  const logFactory = GlobalSite.checkDependency('GlobalSite.logFactory');
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }
  $(() => {
    const $amountInput = $('.hp-banner-container #credit-simulator-value--slider');
    const $startSimulatorButton = $('.hp-banner-container #credit-simulator-button--slider');
    const $amountMessage = $(
      '.hp-banner-container .credit-simulator .credit-simulator__amount__text',
    );
    const $amountErrorMessage = $(
      '.hp-banner-container .credit-simulator .credit-simulator__amount__text.error',
    );
    const $accessibleAmountMessage = $(
      '.hp-banner-container .credit-simulator .accessible-message',
    );
    const $accessibleAmountErrorMessage = $(
      '.hp-banner-container .credit-simulator .accessible-message-error',
    );

    const creditSimuUi = GlobalSite.checkDependency('GlobalSite.creditSimulatorUi')(
      $amountInput,
      $startSimulatorButton,
      $amountMessage,
      $amountErrorMessage,
      $accessibleAmountMessage,
      $accessibleAmountErrorMessage,
    );
    creditSimuUi.domHandler();

    const btnBanner = document.querySelectorAll('.button');

    const getOriginMobileFromUrl = () => {
      const params = new URLSearchParams(window.location.search);
      return params.get('originMobile'); 
    };

    btnBanner.forEach((btnStickyItem) => {
      btnStickyItem.addEventListener('click', (e) => {
        const originMobile = getOriginMobileFromUrl();

        if (!originMobile) {
          return; 
        }

        e.preventDefault();

        const baseHref = btnStickyItem.href;

        const separator = baseHref.includes('?') ? '&' : '?';

        const paramsToAdd = [];

        if (originMobile) {
          paramsToAdd.push(`originMobile=${encodeURIComponent(originMobile)}`);
        }
        const redirectTo = paramsToAdd.length
          ? `${baseHref}${separator}${paramsToAdd.join('&')}`
          : baseHref; 

        window.location.replace(redirectTo);
      });
    });
  });
})();
